import { render, staticRenderFns } from "./NabidkyList.vue?vue&type=template&id=64f522a2&"
import script from "./NabidkyList.vue?vue&type=script&lang=ts&"
export * from "./NabidkyList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports